import React from "react";
import { Grid, Typography, IconButton } from "@mui/material";
import DragIndicator from "@mui/icons-material/DragIndicator";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

export default function WidgetRow({
  widget,
  listeners,
  renderWidget,
  removeWidget,
}) {
  return (
    <Grid container spacing={2} alignItems="flex-start" padding={2}>
      <Grid item xs={1} {...listeners}>
        <DragIndicator
          fontSize="small"
          style={{ cursor: "grab", marginTop: 6 }}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography fontWeight={500}>{`${widget.name} ${
          widget.widgetType === "prize-draw" ? ": Active" : ""
        }`}</Typography>
      </Grid>
      <Grid item xs={7}>
        {renderWidget(widget)}
      </Grid>
      <Grid item xs={1}>
        <IconButton
          onClick={() => removeWidget(widget.widgetId)}
          size="small"
          color="error"
        >
          <RemoveCircleIcon style={{ width: 25, height: 25 }} />
        </IconButton>
      </Grid>
    </Grid>
  );
}
